import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import psv from './PSV';
import AlgorithmBox from './AlgorithmBox';
import Variable from './Variable';
import Knowledge, { readConstants, readVariables } from './Knowledge';
import Party from './Party';
import EventBox from './EventBox';
import Message from './Message';
import Finalise from './Finalise';
import ModalDialog from './ModalDialog';
import Assignment from './Assignment';
import Tool from './Tool';
import ToolsetBox from './ToolsetBox';
import KnowledgeElement from './KnowledgeElement';
import TypeSet, { stringSet } from './TypeSet';
import Function from './Function';
import PreBox from './PreBox';
import PostBox from './PostBox';


class Protocol extends React.Component {
  constructor(props) {
    super(props);
    this.finRef = React.createRef();
    
    this.state = {
        messages : props.messages ? props.messages : []
      , messageRefs : props.messageRefs ? props.messageRefs : []
      , parties : props.parties ? props.parties : []
      , finalise : props.finalise ? props.finalise : <Finalise />
      , showAddMessage : false
      , addMessageValidated : false
      , addButton : undefined
      , knowledges : props.knowledges ? props.knowledges : []
      , knowledgeRefs : props.knowledgeRefs ? props.knowledgeRefs : []
    };
    
    // Add button
    this.state.addButton = this.getAddButton();
    this.state.knowledges.push([]);
    this.state.knowledges.push([]);
    this.state.knowledges["Alice"] = this.state.knowledges[0];
    this.state.knowledges["Bob"]   = this.state.knowledges[1];
    this.state.knowledgeRefs.push(React.createRef());
    this.state.knowledgeRefs.push(React.createRef());
    this.state.knowledgeRefs["Alice"] = this.state.knowledgeRefs[0];
    this.state.knowledgeRefs["Bob"]   = this.state.knowledgeRefs[1];

    /* Sets */
//     let knowledgeAlice = <Knowledge owner="Alice" elements={this.state.knowledges["Alice"]} mumbleView={true}  readonly={false} ref={this.state.knowledgeRefs["Alice"]}/>;
//     let knowledgeBob = <Knowledge owner="Bob" elements={this.state.knowledges["Bob"]}     mumbleView={true} readonly={false} ref={this.state.knowledgeRefs["Bob"]}/>;
//     let alice = <Party name="Alice" knowledge={knowledgeAlice} />;
//     let bob = <Party name="Bob" knowledge={knowledgeBob} />;
    /*
    let knowledgeAliceFinal = <Knowledge elements={this.state.knowledges["Alice"]} stage={-1} readonly={false} />;
    let knowledgeBobFinal = <Knowledge elements={this.state.knowledges["Bob"]}     stage={-1} readonly={false} />;*/
//     let abAlice = <AlgorithmBox statements={[]} />;
//     let abBob = <AlgorithmBox statements={[]} />;
//     let finals = [
//           [alice, abAlice, knowledgeAliceFinal]
//         , [bob, abBob, knowledgeBobFinal]
//       ];
//     finals["Alice"] = finals[0];
//     finals["Bob"]   = finals[1];
//     
//     let finalise = <Finalise
//       finals={finals}
//       ref={this.finRef}
//       messages={this.state.messages}
//       />;
//     this.state.parties.push(alice);
//     this.state.parties.push(bob);
//     this.state.finalise = finalise;
    
    /*BEGIN Initial Knowledge and parties */
    let plaintexts = <TypeSet name="P" tex='P' description="Plaintexts" />;
    let ciphertexts = <TypeSet name="C" tex='C' description="Encrypted texts" />;
    let publicKeys = <TypeSet name="KP" tex='K_p' description="Set of public keys" />;
    let privateKeys = <TypeSet name="KS" tex='K_s' description="Set of (secret) private keys" />;
    
    // Alice and Bob
    let aliceId = <Function
      name="Alice"
      arity={0}
      symbol="A"
      typesets={[plaintexts]}
      arguments={[]}
      tex="\mathbf{\mathrm{Alice}}"
    />;
    let bobId = <Function
      name="Bob"
      arity={0}
      symbol="B"
      typesets={[plaintexts]}
      arguments={[]}
      tex="\mathbf{\mathrm{Bob}}"
    />;
    
    // functions
    let aenc = <Tool
      text="aenc"
      object=<Function
        name="aenc"
        arity={2}
        notation="plain"
        symbol="aenc"
        typesets={[
            publicKeys
          , plaintexts
          , ciphertexts
        ]}
        arguments={[]}
        tex="\mathrm{Enc}"
      />
    />;
    let adec = <Tool
      text="adec"
      object=<Function
        name="adec"
        arity={2}
        notation="plain"
        symbol="adec"
        typesets={[
            publicKeys
          , plaintexts
          , ciphertexts
        ]}
        arguments={[]}
        tex="\mathrm{Dec}"
      />
    />;
    let concat = <Tool
      text="concat"
      object=<Function
        name="concat"
        arity={2}
        notation="infix"
        symbol="concat"
        hint="tuple"
        typesets={[
            plaintexts
          , plaintexts
          , plaintexts
        ]}
        arguments={[]}
        tex="|"
      />
    />;
    let fst = <Tool
      text="fst"
      object=<Function
        name="fst"
        arity={1}
        notation="plain"
        symbol="fst"
        hint="projection|1"
        typesets={[
            plaintexts
          , plaintexts
        ]}
        arguments={[]}
        tex="\mathrm{fst}"
      />
    />;
    let snd = <Tool
      text="snd"
      object=<Function
        name="snd"
        arity={1}
        notation="plain"
        symbol="snd"
        hint="projection|2"
        typesets={[
            plaintexts
          , plaintexts
        ]}
        arguments={[]}
        tex="\mathrm{snd}"
      />
    />;

    // Keys exchanged securely with S
    let skA = <Function
      name="skA"
      arity={0}
      notation="plain"
      symbol="skA"
      typesets={[privateKeys]}
      arguments={[]}
      tex="sk_A"
      hint="asym private-key"
    />;
    let skB = <Function
      name="skB"
      arity={0}
      notation="plain"
      symbol="skB"
      typesets={[privateKeys]}
      arguments={[]}
      tex="sk_B"
      hint="asym private-key"
    />;
    let pkA = <Function
      name="pkA"
      arity={0}
      notation="plain"
      symbol="pkA"
      typesets={[publicKeys]}
      arguments={[]}
      tex="pk_A"
      hint="asym public-key"
    />;
    let pkB = <Function
      name="pkB"
      arity={0}
      notation="plain"
      symbol="pkB"
      typesets={[publicKeys]}
      arguments={[]}
      tex="pk_B"
      hint="asym public-key"
    />;
    let keSkA = <KnowledgeElement content={skA} stage="0" />;
    let keSkB = <KnowledgeElement content={skB} stage="0" />;
    let kePkA = <KnowledgeElement content={pkA} stage="0" />;
    let kePkB = <KnowledgeElement content={pkB} stage="0" />;
    
    let knowledgeAlice = <Knowledge elements={[keSkA, kePkB]} mumbleView={true}  readonly={false} ref={this.state.knowledgeRefs["Alice"]}/>;
    let knowledgeBob = <Knowledge elements={[keSkB, kePkA]} mumbleView={true} readonly={false} ref={this.state.knowledgeRefs["Bob"]}/>;
    
    let alice = <Party name="Alice" knowledge={knowledgeAlice} />;
    let bob = <Party name="Bob" knowledge={knowledgeBob} />;

    this.state.parties.push(alice);
    this.state.parties.push(bob);
    /*END Initial Knowledge and parties */
    
    /*BEGIN First message */
    let ni = <Variable name="ni" typeset={plaintexts} tex="\nu_i"/>;
    let sampleNi = <Assignment lvalue={ni} rvalue={plaintexts} deterministic={false}/>;
    let keni = <KnowledgeElement content={ni} stage="0" />;
    
    let m1 = <Variable name="m1" typeset={ciphertexts} tex="m_1"/>;
    let p1 = <Function
      name="concat" arity={2} notation="infix"       symbol="concat" hint="tuple" tex="|"
      typesets={[plaintexts, plaintexts, plaintexts]}
      arguments={[ni, aliceId]}
    />;
    let aencM1 = <Function
      name="aenc" arity={2} notation="plain" symbol="aenc" tex="\mathrm{Enc}"
      typesets={[publicKeys, plaintexts, ciphertexts]}
      arguments={[pkB, p1]}
    />;
    let m1ass = <Assignment lvalue={m1} rvalue={aencM1} deterministic={true}/>;
    let keM1 = <KnowledgeElement content={m1} stage="0" />;
    
    let pre1 = <PreBox statements={[sampleNi, m1ass]} stage="1"/>;
    let event1 = <EventBox variables={[m1]} direction="send" stage="1"/>;
    let post1 = <PostBox statements={[]} stage="1" />;
    
    let knowledgeAliceMsg1 = <Knowledge elements={knowledgeAlice.props.elements.concat([keni, keM1])} mumbleView={false} readonly={true}/>;
    let   knowledgeBobMsg1 = <Knowledge elements={knowledgeBob.props.elements.concat([keM1])} mumbleView={false} readonly={true}/>;
    
    let message1 = 
      <Message 
        fromParty={"alice"}
        toParty={"bob"}
        knowledgeLeft={knowledgeAliceMsg1}
        knowledgeRight={knowledgeBobMsg1}
        direction={"send"} 
        stage={0}
        pre={pre1} 
        event={event1} 
      />;
    this.state.messages.push(message1);
    /*END First message */
    
    /*BEGIN Second message */
    let adecM1 = <Function
      name="adec" arity={2} notation="plain" symbol="adec" tex="\mathrm{Dec}"
      typesets={[privateKeys, ciphertexts, plaintexts]}
      arguments={[skB, m1]}
    />;
    let adecM1fst = <Function
      name="fst" arity={1} notation="plain" symbol="fst" hint="projection|1" tex="\mathrm{fst}"
      typesets={[plaintexts, plaintexts]}
      arguments={[adecM1]}
    />;
    let niass = <Assignment lvalue={ni} rvalue={adecM1fst} deterministic={true}/>;
    
    let nr = <Variable name="nr" typeset={plaintexts} tex="\nu_r"/>;
    let sampleNr = <Assignment lvalue={nr} rvalue={plaintexts} deterministic={false}/>;
    let kenr = <KnowledgeElement content={nr} stage="2" />;
    
    let m2 = <Variable name="m2" typeset={ciphertexts} tex="m_2"/>;
    let p2 = <Function
      name="concat" arity={2} notation="infix" symbol="concat" hint="tuple" tex="|"
      typesets={[plaintexts, plaintexts, plaintexts]}
      arguments={[ni, nr]}
    />;
    let aencM2 = <Function
      name="aenc" arity={2} notation="plain" symbol="aenc" tex="\mathrm{Enc}"
      typesets={[publicKeys, plaintexts, ciphertexts]}
      arguments={[pkA, p2]}
    />;
    let m2ass = <Assignment lvalue={m2} rvalue={aencM2} deterministic={true}/>;
    let keM2 = <KnowledgeElement content={m2} stage="2"/>;
    
    let pre2 = <PreBox statements={[niass, sampleNr, m2ass]} stage="2"/>;
    let event2 = <EventBox variables={[m2]} direction="receive" stage="2"/>;
    let post2 = <PostBox statements={[]} stage="2" />;
 
    let knowledgeAliceMsg2 = <Knowledge elements={knowledgeAliceMsg1.props.elements.concat([keM2])} mumbleView={false} readonly={true} stage="2"/>;
    let knowledgeBobMsg2 = <Knowledge elements={knowledgeBobMsg1.props.elements.concat([keni, kenr, keM2])} mumbleView={false} readonly={true} stage="2"/>;
    
    let message2 = <Message fromParty={alice} toParty={bob} pre={pre2} event={event2} knowledgeLeft={knowledgeBobMsg2} knowledgeRight={knowledgeAliceMsg2} direction="receive"/>;
    this.state.messages.push(message2);
    /*END Second message */
    
    /*BEGIN Third message */
    let adecM2 = <Function
      name="adec" arity={2} notation="plain" symbol="adec" tex="\mathrm{Dec}"
      typesets={[privateKeys, ciphertexts, plaintexts]}
      arguments={[skA, m2]}
    />;
    let adecM2snd = <Function
      name="snd" arity={1} notation="plain" symbol="snd" hint="projection|2" tex="\mathrm{snd}"
      typesets={[plaintexts, plaintexts]}
      arguments={[adecM2]}
    />;
    let nrass = <Assignment lvalue={nr} rvalue={adecM2snd} deterministic={true}/>;
    
    let m3 = <Variable name="m3" typeset={ciphertexts} tex="m_3"/>;
    let aencM3 = <Function
      name="aenc" arity={2} notation="plain" symbol="aenc" tex="\mathrm{Enc}"
      typesets={[publicKeys, plaintexts, ciphertexts]}
      arguments={[pkB, nr]}
    />;
    let m3ass = <Assignment lvalue={m3} rvalue={aencM3} deterministic={true}/>;
    let keM3 = <KnowledgeElement content={m3} stage="3" />;

    let pre3 = <PreBox statements={[nrass, m3ass]} stage="3"/>;
    let event3 = <EventBox variables={[m3]} direction="send" stage="3"/>;
    let post3 = <PostBox statements={[]} stage="3" />;
 
    let knowledgeAliceMsg3 = <Knowledge elements={knowledgeAliceMsg2.props.elements.concat([kenr, keM3])} mumbleView={false} readonly={true} stage="3"/>;
    let knowledgeBobMsg3 = <Knowledge elements={knowledgeBobMsg2.props.elements.concat([keM3])} mumbleView={false} readonly={true} stage="3"/>;
    
    let message3 = <Message fromParty={alice} toParty={bob} pre={pre3} event={event3} knowledgeLeft={knowledgeAliceMsg3} knowledgeRight={knowledgeBobMsg3} direction="send" stage={3} />;
    this.state.messages.push(message3);
     
    let finalise = <Finalise ref={this.finRef}
      finals={[
          [alice, [], knowledgeAliceMsg3]
        , [bob, [], knowledgeBobMsg3]
      ]} />;
 
     this.state.finalise = finalise;
    /*END Finalise */
  }
  
  getAddButton = () => (<></>);
  
  showModalDialog = () => {
    var state = this.state;
    state.showAddMessage = true;
    this.setState(state);
  }
  
  hideModalDialog = () => {
    var state = this.state;
    state.showAddMessage = false;
    this.setState(this.state);
  }
  
  declareStatements = (statements, entity) => {
    if (statements) {
      //console.log(statements[0].props.lvalue.props.typeset.props.name);
      return (
        statements.map((ke) =>
          <declaration
            variable={ke.props.lvalue.props.name}
            entity={entity}
            set={ke.props.lvalue.props.typeset.props.name}
            hint={ke.props.lvalue.props.hint}
          >
          </declaration>
        )
      );
    } else {
      return <></>;
    }
  }
  
  addMessage = () => {    
    var state = this.state;
    var messageRef = React.createRef();
    
    let   knowledgeBobMsg = <Knowledge elements={this.state.knowledges["Bob"]}   stage={this.state.messages.length + 1} readonly={false} />;
    let knowledgeAliceMsg = <Knowledge elements={this.state.knowledges["Alice"]} stage={this.state.messages.length + 1} readonly={false} />;
    let fromIdx = document.getElementById('addMessage.fromParty').value;
    let toIdx = document.getElementById('addMessage.toParty').value;
    let direction = (fromIdx - toIdx > 0) ? "receive" : "send";
    
    state.messageRefs.push(messageRef);
    state.messages.push(
      <Message
        fromParty={this.state.parties[fromIdx]}
        toParty={this.state.parties[toIdx]}
        knowledgeLeft={knowledgeAliceMsg}
        knowledgeRight={knowledgeBobMsg}
        direction={direction}
        stage={state.messages.length + 1}
        ref={messageRef}
      />);
    state.showAddMessage = true;
    state.addButton = this.getAddButton();
    
    this.hideModalDialog(); // this also updates the state
  }
  
  toPSV =() => {
      return(
    <>
       <sets>
      <set id="N" tex="\mathbb{N}" description="Natural numbers"></set>
      <set id="Zp" tex="\mathbb{Z}_p" description="Integers modulo p"></set>
      <set id="S" tex="\Sigma^{\star}" description="All strings"></set>
      <set id="P" tex="P" description="Plaintexts"></set>
      <set id="C" tex="C" description="Ciphertexts"></set>
      <set id="KP" tex="K_p" description="Publick keys"></set>
      <set id="KS" tex="K_s" description="Private keys"></set>
  </sets>

  <customfunctions>
      <function id="pI" tex="I"><argset set="P"></argset></function>
      <function id="aenc" arity="2" hint="asym encryption">
          <argset set="KP"></argset>
          <argset set="P"></argset>
          <argset set="C"></argset>
      </function>
      <function id="adec" arity="2" hint="asym decryption">
          <argset set="KS"></argset>
          <argset set="C"></argset>
          <argset set="P"></argset>
      </function>
      <function id="pk" arity="1" hint="asym public-key">
          <argset set="KS"></argset>
          <argset set="KP"></argset>
      </function>
      <function id="concat" arity="2" tex="|" notation="infix" hint="tuple">
          <argset set="P"></argset>
          <argset set="P"></argset>
          <argset set="P"></argset>
      </function>
      <function id="fst" arity="1" hint="projection|1">
          <argset set="P"></argset>
          <argset set="P"></argset>
      </function>
      <function id="snd" arity="1" hint="projection|2">
          <argset set="P"></argset>
          <argset set="P"></argset>
      </function>
  </customfunctions>

  <declarations>
    <declaration variable="ni"  tex="n_i" entity="I" set="P"></declaration>
    <declaration variable="m1"  tex="m_1" entity="I" set="C"></declaration>
    <declaration variable="m3"  tex="m_3" entity="I" set="C"></declaration>
    <declaration variable="skI" tex="k_I"     entity="I" set="KS" hint="asym private-key"></declaration>
    <declaration variable="pkI" tex="pk(k_I)" entity="R" set="KP" hint="asym public-key"></declaration>
    <declaration variable="nr"  tex="n_r" entity="R" set="P"></declaration>
    <declaration variable="m2"  tex="m_2" entity="R" set="C"></declaration>
    <declaration variable="skR" tex="k_R"     entity="R" set="KS" hint="asym private-key"></declaration>
    <declaration variable="pkR" tex="pk(k_R)" entity="I" set="KP" hint="asym public-key"></declaration>
  </declarations>
  
  <customequations>
    <equation id="skI-pkI">
      <application function="pk">
          <argument id="skI"></argument>
      </application>
      <variable id="pkI"></variable>
    </equation>
    <equation id="skR-pkR">
      <application function="pk">
          <argument id="skR"></argument>
      </application>
      <variable id="pkR"></variable>
    </equation>
  </customequations>
  
  <protocol name="Needham Schroeder Protocol">
    <description>Authenticating Two Parties</description>
    
    <entity id="I" name="I" desc="Initiator"></entity>
    <entity id="R" name="R" desc="Responder"></entity>
    
    <message id="m-1" from="I" to="R">
      <knowledge entity="I">
        <variable id="skI"></variable>
        <variable id="pkR"></variable>
      </knowledge>
      <knowledge entity="R">
        <variable id="skR"></variable>
        <variable id="pkI"></variable>
      </knowledge>
      <pre>
        <assignment variable="ni" type="probabilistic"></assignment>
        <assignment variable="m1">
            <application function="aenc">
                <argument id="pkR"></argument>
                <application function="concat">
                    <argument id="ni" type="nonce"></argument>
                    <argument id="pI" type="entity"></argument>
                </application>
            </application>
          </assignment>
        </pre>
        <event type="send">
          <variable id="m1"></variable>
        </event>
        <channel security="insecure"></channel>
        <event type="receive">
            <variable id="m1"></variable>
        </event>
        <post>
        </post>
    </message>
    
    <message id="m-2" from="R" to="I">
      <knowledge entity="I">
        <variable id="skI"></variable>
        <variable id="pkR"></variable>
        <variable id="ni"></variable>
        <variable id="m1"></variable>
      </knowledge>
      <knowledge entity="R">
        <variable id="skR"></variable>
        <variable id="pkI"></variable>
        <variable id="m1"></variable>
      </knowledge>
      <pre>
        <assignment variable="nr" type="probabilistic"></assignment>
        <assignment variable="ni">
          <application function="fst">
            <application function="adec">
              <argument id="skR"></argument>
              <argument id="m1"></argument>  
            </application>
          </application>
        </assignment> 
        <assignment variable="m2">
            <application function="aenc">
              <argument id="pkI"></argument>
              <application function="concat">
                  <argument id="ni"></argument>
                  <argument id="nr" type="nonce"></argument>
              </application>
            </application>
          </assignment>
        </pre>
        <event type="send">
          <variable id="m2"></variable>
        </event>
        <channel security="insecure"></channel>
        <event type="receive">
            <variable id="m2"></variable>
        </event>
        <post></post>
    </message>
    <message id="m-3" from="I" to="R">
      <knowledge entity="I">
        <variable id="skI"></variable>
        <variable id="pkR"></variable>
        <variable id="ni"></variable>
        <variable id="m1"></variable>
        <variable id="m2"></variable>
      </knowledge>
      <knowledge entity="R">
        <variable id="skR"></variable>
        <variable id="pkI"></variable>
        <variable id="m1"></variable>
        <variable id="nr"></variable>
        <variable id="ni"></variable>
        <variable id="m2"></variable>
      </knowledge>
        <pre>
          <assignment variable="nr">
            <application function="snd">
                <application function="adec">
                  <argument id="skI"></argument>
                  <argument id="m2"></argument>  
                </application>
             </application>
          </assignment> 
          <assignment variable="m3">
             <application function="aenc">
               <argument id="pkR"></argument>
               <argument id="nr"></argument>
             </application>
          </assignment>
        </pre>
        <event type="send">
          <variable id="m3"></variable>
        </event>
        <channel security="insecure"></channel>
        <event type="receive">
          <variable id="m3"></variable>
        </event>
        <post></post>
    </message>
    
    <finalise entity="I" lastmessage="m-3">
        <assignment variable="ni">
          <variable id="ni"></variable>
        </assignment>
    </finalise>

    <finalise entity="R" lastmessage="m-3">
        <assignment variable="ni">
          <variable id="ni"></variable>
        </assignment>
    </finalise>

    <properties>
      <securityparameter id="n">512</securityparameter>
      <authentication integrity="I" towards="R"></authentication>
      <authentication integrity="R" towards="I"></authentication>
    </properties>
  </protocol>
    </>
    );
      
}
  toPSV_old = () => {
    var fromParty = this.state.parties[0];
    var toParty = this.state.parties[1];
    var finalise = "";
    
    if (this.finRef && this.finRef.current) {
      finalise = this.finRef.current.toPSV();
    }
    
    
    // TODO: move to Party
    const entities = this.state.parties.map((p) =>
      <entity
        id={p.props.name}
        name={p.props.name}
        desc={p.props.name}
      >
        {this.state.knowledgeRefs[p.props.name].current.decoratedRef.current.toPSV()}
      </entity>
    );
    
    // TODO: Filter out builtin and functions/0
      // WARNING: duplicates of common initial knowledge and wrong format!
//         {this.state.parties.map((p) => {
//           return (
//             <>
//               {readConstants(this.state.knowledgeRefs[p.props.name].current.decoratedRef.current.state.boxes, 0)}
//               {readVariables(this.state.knowledgeRefs[p.props.name].current.decoratedRef.current.state.boxes, 0)}
//             </>
//           );
//         })}
    const declarations = 
      <>
        {this.state.messageRefs.map((m) =>
          this.declareStatements(m.current.preRef.current.state.statements, m.current.state.left.props.name)
        )}
        {this.finRef.current.state.finals.map((pak) =>
          this.declareStatements(pak[1].props.statements, pak[0].props.name)
        )}
        {this.state.messageRefs.map((m) =>
          this.declareStatements(m.current.preRef.current.state.statements, m.current.state.left.props.name)
        )}
      </>;
    
        
    
//     this.state.parties.map((p) => 
//       this.state.knowledgeRefs[p.props.name].current.decoratedRef.current.state.boxes
//         .filter((ke) => ke.props.content.type === <Variable />.type)
//         .map((ke) => 
//           <declaration
//             variable={ke.props.content.props.name}
//             entity={p.props.name}
//           >
//           </declaration>
//         )
//       );
    return (
      <>
        <declarations>
          {declarations}
        </declarations>
        <protocol>
          {entities}
          {this.state.messageRefs.map((r) => r.current.toPSV())}
          {finalise}
          <properties>
          </properties>
        </protocol>
      </>
    );
  }
  
  render() {
    var form = getAddMessageForm(this.state.parties);
    var button = (this.state.messages.length > 0)
      ? <Container>
          <Row>
            <Col>
              <ButtonToolbar>
                {this.state.addButton}
              </ButtonToolbar>
            </Col>
          </Row>
        </Container>
      : <Container>
          <Row>
            <Col>
              <ButtonToolbar>
                {this.state.addButton}
              </ButtonToolbar>
            </Col>
            <Col></Col>
            <Col></Col>
          </Row>
        </Container>
    
    return (
      <Container className="protocol">
        <Container className="parties">
          <Row className="parties">
            {this.state.parties.map((b, i) =>
              <Col key={i}>{b}</Col>
            )}
          </Row>
        </Container>
        <Container className="messages">
          {this.state.messages.map((b, i) =>
            <Row key={i} className="message">
              <Col>{b}</Col>
            </Row>
          )}
          {button}
        </Container>
        {this.state.finalise}
        <ModalDialog
          title="Add new message"
          show={this.state.showAddMessage}
          onClose={this.hideModalDialog}
          onApply={this.addMessage}
          form={form} />
      </Container>
    );
  }
}

export function getAddMessageForm(parties) {
  var form = 
    <Form>
      <Form.Group as={Row} controlId="addMessage.fromParty">
        <Form.Label column sm="3">From party: </Form.Label>
        <Col sm="6">
          <Form.Control as="select">
            {parties.map((b,i) =>
              <option key={i} value={i}>{b.props.name}</option>
            )}
          </Form.Control>
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="addMessage.toParty">
        <Form.Label column sm="3">To party: </Form.Label>
        <Col sm="6">
          <Form.Control as="select">
            {parties.map((b,i) =>
              <option key={i} value={i}>{b.props.name}</option>
            )}
          </Form.Control>
        </Col>
        <Form.Control.Feedback type="valid">You did it!</Form.Control.Feedback>
      </Form.Group>
    </Form>;
  
  return form;
}

export default psv(Protocol);
